module.exports = __webpack_public_path__ + "static/media/Dayly_ios_5_preview.ef0122dd.jpg";